import { GenericExportProgressModal } from './index';
import { ChronologyExportEvent } from '@/api/hooks/useChronologyExportEvents';
import { APIBaseChronos } from '@/api/hosts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  matterId: string;
  subsetId: string;
  chronologyId: string;
  chronologyTitle: string;
  onDownload: () => Promise<void>;
  isCreating: boolean;
  error?: string;
}

/**
 * Progress modal for chronology exports with source documents.
 * Thin wrapper around GenericExportProgressModal with chronology-specific configuration.
 */
export const ChronologyExportProgressModal = ({
  isOpen,
  onClose,
  matterId,
  subsetId,
  chronologyId,
  chronologyTitle,
  onDownload,
  isCreating,
  error,
}: Props) => {
  return (
    <GenericExportProgressModal<ChronologyExportEvent>
      isOpen={isOpen}
      onClose={onClose}
      exportConfig={{
        progressEndpoint: `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/chronology/${chronologyId}/export-progress`,
      }}
      itemName={`Chronology "${chronologyTitle}"`}
      onDownload={onDownload}
      isCreating={isCreating}
      error={error}
    />
  );
};
